const lbaConfirmButton = angular.module('app.lbaConfirmButton', []);

lbaConfirmButton.controller('lbaConfirmButtonCtrl', require('./lbaConfirmButtonCtrl'));
lbaConfirmButton.directive('lbaConfirmButton', require('./lbaConfirmButtonDir'));

export default lbaConfirmButton;



// WEBPACK FOOTER //
// ./src/components/lbaConfirmButton/index.js